import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import ShowLoading from '../helperComponent/ShowLoading';
import ReactPlayer from 'react-player';
import axios from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import AddLectureForm from './AddLectureForm';

toast.configure();

const Sections = () => {
  const [sections, setSections] = useState([]);
  const [lectures, setLectures] = useState(0);
  const [addLecture, setAddLecture] = useState(false);
  const [buttonText, setButtonText] = useState('Add Lecture');
  const [play, setPlay] = useState(false);
  const [url, setUrl] = useState('');
  const [showLoading, setShowLoading] = useState(true);

  const { id } = useParams();
  let history = useHistory();
  const uname = JSON.parse(localStorage.getItem('uname'));
  let fetchURL = `https://stucharge.bakersbrisk.com/api/sectionapi?username=${uname}&id=${id}`;
  const AuthStr = process.env.REACT_APP_AUTH_STR;

  // fetch notes
  useEffect(() => {
    axios
      .get(fetchURL, { headers: { Authorization: AuthStr } })
      .then((response) => {
        // If request is good...
        if (response.status === 200) {
          localStorage.setItem('subjects', JSON.stringify(response.data));
          setSections(response.data);
          setLectures(response.data.lectures.length);
          setShowLoading(false);
        } else if (response.status !== 200)
          toast.error('Something went wrong, please refresh');
      })
      .catch((error) => {
        if (error) console.log(error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchURL]);

  //delete handler
  const handleDelete = (key) => {
    const deleteURL = `https://stucharge.bakersbrisk.com/api/lectureapi?username=${uname}&id=${key}`;
    Swal.fire({
      title: 'Are you sure? lecture will be deleted permanantly',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: `Yes`,
      denyButtonText: `No`,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteSection(deleteURL);
        Swal.fire('Lecture deleted!', '', 'success').then((result) => {
          if (result.isConfirmed || !result.isConfirmed) {
            history.push('/home');
            history.push(`/courses/section/${id}`);
          }
        });
      } else if (result.isDenied) {
        Swal.fire('Lecture not deleted!', '', 'info');
      }
    });
  };

  // making delete request
  const deleteSection = async (deleteURL) => {
    const res = await axios.delete(deleteURL, {
      headers: { Authorization: AuthStr },
    });
    if (res.status !== 200) {
      Swal.fire('Error deleting data!', '', 'error');
    }
  };

  // on click handler
  const onClickHandler = () => {
    setAddLecture(!addLecture);
    setButtonText(buttonText === 'Add Lecture' ? 'Close' : 'Add Lecture');
  };

  const handlePlay = (url) => {
    setPlay(true);
    setUrl(url);
  };

  if (play) {
    return (
      <div className='video-wrapper'>
        <ReactPlayer url={url} />
        <button
          className='bttn'
          style={{ width: '120px', margin: '40px auto', background: '#ff7171' }}
          onClick={() => setPlay(false)}
        >
          Return
        </button>
      </div>
    );
  }

  return (
    <div className='wrapper'>
      <div className='main_container'>
        <div className='main_title course'>
          <div className='main_greeting'>
            <h1>Section : {sections.title}</h1>
            {showLoading && <ShowLoading />}
          </div>
        </div>

        <div className='add-notes'>
          <button
            onClick={onClickHandler}
            style={{
              background: addLecture ? '#ef4f4f' : '#ff7171',
            }}
          >
            {buttonText}
          </button>
        </div>

        {addLecture && <AddLectureForm id={id} />}

        {lectures > 0 ? (
          <div className='table-container' style={{ margin: '30px auto' }}>
            <table className='table' style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Title</th>
                  <th>View</th>
                  <th>Edit</th>
                  <th>Delete</th>
                </tr>
              </thead>

              <tbody>
                {sections.lectures.map((item, index) => (
                  <tr key={item.id} style={{ transform: 'none' }}>
                    <td data-label='#'>{index + 1}</td>
                    <td data-label='Title' className='text-title'>
                      {item.title}
                    </td>
                    <td data-label='View'>
                      <button
                        onClick={() => handlePlay(item.video_url)}
                        className='bttn view'
                        rel='noreferrer noopener'
                      >
                        View
                      </button>
                    </td>
                    <td data-label='Edit'>
                      <a
                        href={`/courses/section/edit/${item.id}`}
                        className='bttn update'
                        rel='noreferrer noopener'
                      >
                        Edit
                      </a>
                    </td>
                    <td data-label='Delete'>
                      <button
                        href='/'
                        className='bttn delete'
                        rel='noreferrer noopener'
                        onClick={() => handleDelete(item.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className='alert-heading'>
            <h1>No Lecture added</h1>
          </div>
        )}
      </div>
    </div>
  );
};

export default Sections;
